export function getDeviceCapabilities(device) {
  if (!device || typeof device.getCapabilities !== 'function') return {}

  try {
    return device.getCapabilities() || {}
  } catch (error) {
    return {}
  }
}
